import React from 'react';

interface FloatingActionButtonProps {
  onClick: () => void;
  icon?: React.ReactNode;
  className?: string;
  'aria-label'?: string;
}

export function FloatingActionButton({
  onClick,
  icon = <PlusIcon />,
  className = '',
  'aria-label': ariaLabel = 'Add new event',
}: FloatingActionButtonProps) {
  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel}
      className={`
        fixed bottom-6 right-6 z-50
        w-14 h-14 bg-primary-500 hover:bg-primary-600 active:bg-primary-700
        text-white rounded-full shadow-lg hover:shadow-xl
        flex items-center justify-center
        transition-all duration-200 ease-in-out
        transform hover:scale-105 active:scale-95
        md:hidden
        ${className}
      `}
    >
      {icon}
    </button>
  );
}

function PlusIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}